// A match is watched by its id. The id is a random UUID, so knowing it is the
// invitation: a player shares `?watch=<id>`, and the lobby accepts either form.

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** The match id inside a pasted id or watch link, or null. */
export function parseWatchTarget(input: string): string | null {
  const m = UUID.exec(input.trim());
  return m ? m[0].toLowerCase() : null;
}

/** The link a player can hand a friend. */
export function watchLink(origin: string, matchId: string): string {
  return `${origin}/?watch=${encodeURIComponent(matchId)}`;
}

/** `?watch=` from the page URL, if it holds a match id. */
export function watchFromSearch(search: string): string | null {
  const v = new URLSearchParams(search).get('watch');
  return v ? parseWatchTarget(v) : null;
}
